<template>
    <div>
        <div class="card-body">
            <div class="btn-toolbar justify-content-between mb-2" role="toolbar">
                <div class="col-w">

                </div>
                <div class="input-group">
                    <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                    <button class="btn btn-secondary" @click.stop="massSearch">
                        <i class="fas fa-search"></i>
                        {{ $t('buttons.search.btnText') }}
                    </button>
                    <button class="btn btn-secondary"
                            @click.stop="clearFilters">
                        <i class="fas fa-times"></i>
                        {{ $t('buttons.clearFilters.btnText') }}
                    </button>
                </div>
            </div>

            <kendo-datasource ref="datasource1"
                              :transport="transportSettings"
                              :schema-model-id="'id'"
                              :schema-model-fields="schemaModelFields"
                              :schema-total="'count'"
                              :schema-data="'items'"
                              :page-size='defaultGridRows'
                              :error="dataSourceError"
                              :requestEnd="datasorceRequestEnd">
            </kendo-datasource>

            <kendo-grid ref="grid"
                        :data-source-ref="'datasource1'"
                        :navigatable="gridOptions.navigatable"
                        :editable="editable"
                        :filterable="gridOptions.filterable"
                        :pageable="gridOptions.pageable"
                        :reorderable="gridOptions.reorderable"
                        :resizable="gridOptions.resizable"
                        :groupable="gridOptions.groupable"
                        :allow-copy="gridOptions.allowCopy"
                        :column-menu="gridOptions.columnMenu"
                        :sortable-mode="gridOptions.sortable.mode"
                        :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                        :sortable-show-indexes="gridOptions.sortable.showIndexes"
                        :selectable="gridOptions.selectable"
                        :scrollable="gridOptions.scrollable"
                        :remove="itemDeletion"
                        :toolbar="toolbar">
                <kendo-grid-column :command="command"
                                   :title="$t('actions')"
                                   :width="150">
                </kendo-grid-column>
                <kendo-grid-column :field="'id'"
                                   :filterable="false"
                                   :title="$t('finance.tariffItem.gridHeaders.id')"
                                   :width="100"
                                   :hidden="true">
                </kendo-grid-column>
                <kendo-grid-column :field="'itemNumber'"
                                   :title="$t('finance.tariffItem.gridHeaders.itemNumber')"
                                   :width="200">
                </kendo-grid-column>
                <kendo-grid-column :field="'groupName'"
                                   :title="$t('finance.tariffItem.gridHeaders.group')"
                                   :editable="false"
                                   :width="150">
                </kendo-grid-column>
                <kendo-grid-column :field="'groupModel'"
                                   :title="$t('finance.tariffItem.gridHeaders.group')"
                                   :editor="groupIdDropDownEditor"
                                   :template="groupCellTemplate"
                                   :filterable="false"
                                   :hidden="true"
                                   :groupable="false"
                                   :sortable="false"
                                   :width="150">
                </kendo-grid-column>
                <kendo-grid-column :field="'name'"
                                   :title="$t('finance.tariffItem.gridHeaders.name')"
                                   :width="200">
                </kendo-grid-column>
                <kendo-grid-column :field="'nameEn'"
                                   :title="$t('finance.tariffItem.gridHeaders.nameEn')"
                                   :width="200">
                </kendo-grid-column>
                <kendo-grid-column :field="'code'"
                                   :title="$t('finance.tariffItem.gridHeaders.code')"
                                   :width="200">
                </kendo-grid-column>
                <kendo-grid-column :field="'description'"
                                   :title="$t('finance.tariffItem.gridHeaders.description')"
                                   :width="200">
                </kendo-grid-column>
                <kendo-grid-column :field="'specification'"
                                   :title="$t('finance.tariffItem.gridHeaders.specification')"
                                   :width="200">
                </kendo-grid-column>
                <kendo-grid-column :field="'package'"
                                   :title="$t('finance.tariffItem.gridHeaders.package')"
                                   :width="200">
                </kendo-grid-column>
                <kendo-grid-column :field="'deactivated'"
                                   :title="$t('finance.tariffItem.gridHeaders.deactivated')"
                                   :hidden="true"
                                   :width="120">
                </kendo-grid-column>
                <kendo-grid-column :field="'deleted'"
                                   :template="deletedCellTemplate"
                                   :title="$t('finance.tariffItem.gridHeaders.deleted')"
                                   :width="150">
                </kendo-grid-column>
                <kendo-grid-column :field="'active'"
                                   :template="activeCellTemplate"
                                   :title="$t('finance.tariffItem.gridHeaders.active')"
                                   :width="150">
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'; // това се изисква за да се вмъкват kendo ui компоненти. Виж метод parentIdDropDownEditor
    import { mapGetters } from 'vuex'

    export default {
        components: {

        },
        data: function () {
            return {
                searchQuery: '',
                defaultGridRows: this.$store.getters.defaultGridRows,
                schemaModelFields: {
                    id: { field: 'id', type: 'number', nullable: false, editable: false },
                    itemNumber: { field: 'itemNumber', type: 'string', nullable: true, editable: true },
                    groupId: { field: 'groupId', type: 'number', nullable: false, editable: false },
                    groupName: { field: 'groupName', type: 'string', nullable: false, editable: false },
                    groupNameEn: { field: 'groupNameEn', type: 'string', nullable: false, editable: false },
                    name: { field: 'name', type: 'string', nullable: false, editable: true, validation: { required: true } },
                    nameEn: { field: 'nameEn', type: 'string', nullable: true, editable: true },
                    description: { field: 'description', type: 'string', nullable: true, editable: true },
                    specification: { field: 'specification', type: 'string', nullable: true, editable: true },
                    package: { field: 'package', type: 'string', nullable: true, editable: true },
                    code: { field: 'code', type: 'string', nullable: true, editable: true },
                    sort: { field: 'sort', type: 'number', nullable: true, editable: true },
                    deactivated: { field: 'deactivated', type: 'boolean', nullable: false, editable: true, visible: false },
                    updated: { field: 'updated', type: 'boolean', nullable: false, editable: false },
                    deleted: { field: 'deleted', type: 'boolean', nullable: false, editable: false },
                    groupModel: {
                        defaultValue: { id: 0, text: 'Избери...', textEx: 'Select...' }
                        , validation: {
                            required: true, groupnamevalidation: function (input) {
                                if (input.is("[name='groupModel']")) {
                                    let val = Number(input.val());
                                    if (isNaN(val) || val === 0) {
                                        input.attr("data-groupnamevalidation-msg", this.$t('validation.requiredField'));
                                        return /^[A-Z]/.test(input.val());
                                    }
                                }

                                return true;
                            }.bind(this)
                        }
                    },
                    active: { field: 'active', type: 'boolean', nullable: false, editable: false, visible: true }
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/tariffs/listItems',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    create: {
                        url: this.$store.getters.baseUrl + '/api/tariffs/createItem',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    update: {
                        url: this.$store.getters.baseUrl + '/api/tariffs/updateItem',
                        dataType: 'json',
                        type: 'PUT',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    destroy: {
                        url: this.$store.getters.baseUrl + '/api/tariffs/deleteItem',
                        dataType: 'json',
                        type: 'DELETE',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                editable: {
                    mode: 'popup', /* inline, popup */
                    window: {
                        title: this.$t('finance.tariffItem.title'),
                        animation: true
                    },
                    move: true
                }
            }
        },
        methods: {
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    // Викаме POST action за листване на номенклатурите и трябва да сериализираме
                    // options. Така се предава информация за take, skip , page и списък с обекти
                    // описващи сортирането
                    return kendo.stringify(options);
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: this.$helpers.errorColor(e),
                    time: this.$store.getters.notificationDuration,
                })
            },
            datasorceRequestEnd(e) {
                if (e.type == "create" && e.response) {
                    e.sender.read()

                    let statusCode = this.$helpers.errorStatusCode(e);
                    this.$vs.notify({
                        title: this.$t('buttons.create.action'),
                        text: this.$helpers.responseMessage(e.response),
                        color: statusCode === 200 ? 'success' : 'warning',
                        time: this.$store.getters.notificationDuration
                    })
                } else if (e.type == "update" && e.response) {
                    e.sender.read()

                    let statusCode = this.$helpers.errorStatusCode(e);
                    this.$vs.notify({
                        title: this.$t('buttons.edit.action'),
                        text: this.$helpers.responseMessage(e.response),
                        color: statusCode === 200 ? 'success' : 'warning',
                        time: this.$store.getters.notificationDuration
                    })
                } else if (e.type == "destroy" && e.response) {
                    e.sender.read()

                    let statusCode = this.$helpers.errorStatusCode(e);
                    this.$vs.notify({
                        title: this.$t('buttons.delete.action'),
                        text: this.$helpers.responseMessage(e.response),
                        color: statusCode === 200 ? 'success' : 'warning',
                        time: this.$store.getters.notificationDuration
                    })
                }
            },
            groupCellTemplate: function (dataItem) {
                if (dataItem.groupModel === null) {
                    return kendo.htmlEncode("");
                }

                if (dataItem.groupModel.text === null && dataItem.groupModel.textEn === null) {
                    return kendo.htmlEncode("");
                }

                let templateHtml = '<span>' + kendo.htmlEncode(this.isEnVersion ? dataItem.groupModel.textEn : dataItem.groupModel.text) + '</span>';

                return templateHtml;
            },
            groupIdDropDownEditor: function (container, options) {
                $('<input name="' + options.field + '"/> id="' + options.field + '"')
                    .appendTo(container)
                    .kendoDropDownList({
                        autoBind: false,
                        dataTextField: this.isEnVersion ? 'textEn' : 'text',
                        dataValueField: "id",
                        optionLabel: this.$t('selectTariffGroup'),
                        dataSource: {
                            transport: {
                                read: {
                                    url: this.$store.getters.baseUrl + '/api/tariffs/groups',
                                    dataType: 'json',
                                    type: 'GET',
                                    contentType: 'application/json',
                                    beforeSend: this.beforeSend
                                },
                            },
                            requestEnd: this.dropDownEditorDatasorceRequestEnd(options)
                        }
                    });
            },
            dropDownEditorDatasorceRequestEnd(options) {

            },
            deletedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.deleted ? 'badge-danger' : 'badge-success') + '">' + kendo.htmlEncode(dataItem.deleted ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            activeCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.active ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.active ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            itemDeletion(e) {
                if (e.model) {
                    e.preventDefault();
                    this.deleteGroup(e.model.id);
                }
            },
            deleteGroup(id) {
                this.$http.delete('/api/tariffs/deleteItem',
                    { params: { id: id } }
                ).then((response) => {
                    this.$refs.grid.kendoWidget().dataSource.read();
                    this.$vs.notify({
                        title: this.$t('buttons.delete.action'),
                        text: this.$helpers.responseMessage(response),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
        },
        computed: {
            ...mapGetters(['gridOptions']),
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            },
            toolbar: function () {
                if (this.hasCreateRights) {
                    return [{ name: 'create', text: this.$t('buttons.create.btnText') }]
                } else {
                    return [];
                }
            },
            command: function () {
                let cmd = [];
                if (this.hasUpdateRights) {
                    cmd.push({ name: 'edit', text: this.$t('buttons.edit.btnText') });
                }
                if (this.hasDeleteRights) {
                    cmd.push({ name: 'destroy', text: this.$t('buttons.delete.tooltipText') });
                }

                return cmd;
            },
            hasReadRights() {
                return this.$store.getters.claims.tariff.read;
            },
            hasCreateRights() {
                return this.$store.getters.claims.tariff.create;
            },
            hasUpdateRights() {
                return this.$store.getters.claims.tariff.update;
            },
            hasDeleteRights() {
                return this.$store.getters.claims.tariff.delete;
            },
        }
    }
</script>
